import React from 'react';
import LocalizedStrings from 'react-localization';
import ReactHtmlParser from 'react-html-parser';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

const Forbidden = (props) => {
    const content = props.user.role ? strings.clientContent : strings.patronContent;
    const logStatus = props.user.role ? strings.logout : strings.login
    return ( 
        <div className="showtix-section container">
            <div className="row">
                <div className="col-12">
                    <h1>{strings.please} {logStatus}</h1>
                </div>
            </div>

            <div className="row">
                <div className="col-12 col-lg-8">
                    {ReactHtmlParser(content)}
                </div>
            </div>
        </div>
    );
}
 
export default Forbidden;


// WEBPACK FOOTER //
// ./src/components/Common/Forbidden/Forbidden.js